export const TOAST_MESSAGES = {
  PMRR_FETCH_FAILED: "Failed to fetch Procurement Material Requisitions.",
  PMRR_CREATE_FAILED: "Failed to create PMRR",
  PMRR_UPDATE_FAILED: "Failed to update Procurement Material Requisition.",
  PMRR_SUCCESS: "PMRR created successfully!",
  PMRR_ALREADY_ADDED: "This product is already added!",
  PMRR_NO_DATA: "No Details Available",
  PMRR_DELETE: "PMRR Deleted Successfully",
  FAILED_TO_DELETE_PMRR: "Failed to delete PMRR",
  FAILED_TO_FETCH_WAREHOUSES: "Failed to fetch warehouses!",
  UPDATE_PMRR_SUCCESS: "PMRR Updated Successfully",
  UPDATE_PMRR_FAILED: "Failed to update PMRR",
  FILE_UPLOAD_SUCCESS: "File Uploaded Successfully",
  FILE_UPLOAD_FAILED: "Failed to upload file",
  FILE_DELETE_SUCCESS:"File Deleted Successfully",
  FILE_DELETE_FAILED: "Failed to delete file",
  FAILED_TO_LOAD_FILES: "Failed to load files",
};

export const PMRR_MATERIAL_COLUMNS = [
  "mrr_code",
  "requesting_warehouse_name",
  "estimated_delivery_date",
  "priority",
  "status",
  "created",
  "created_by",
  "actions",
];

export const PMRR_MATERIAL_LABELS = {
  mrr_code: "PMRR Code",
  requesting_warehouse_name: "Requested By (Warehouse)",
  estimated_delivery_date: "Expected Delivery Date",
  priority: "Priority",
  status: "Status",
  created: "Raised On",
  created_by: "Requested By",
  actions: "Actions",
};

export const PMRR_STATUS_VALUE_LABELS = [
  { value: "", label: "All"},
  { value: "DRAFT", label: "Draft" },
  { value: "PENDING_APPROVAL", label: "Pending Approval" },
  { value: "APPROVED", label: "Approved" },
  { value: "PENDING_PROCUREMENT", label: "Pending Procurement" },
  { value: "PENDING_BILLING", label: "Pending Billing"},
  { value: "COMPLETED", label: "Completed" },
  { value: "FAILED", label: "Failed" },
];

export const PMRR_STATUS = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  FAILED: "FAILED",
  PENDING_BILLING: "PENDING_BILLING",
  PENDING_PROCUREMENT: "PENDING_PROCUREMENT",
  COMPLETED: "COMPLETED",
};

// helper.js or constants.js

export const getPMRRStatusColor = (status) => {
  switch (status) {
    case "DRAFT":
      return "bg-gray-100 hover:bg-gray-150 transition-colors text-gray-700";
    case "PENDING_APPROVAL":
      return "bg-blue-50 text-blue-500 transition-colors";
    case "PENDING_BILLING":
        return "bg-yellow-50 text-yellow-500 transition-colors";   
    case "APPROVED":
      return "bg-green-50 text-green-500 transition-colors";
    case "FAILED":
      return "bg-red-50 text-red-500";
    case "PENDING_PROCUREMENT":
      return "bg-cyan-50 text-cyan-500";
    case "COMPLETED":
      return "bg-purple-50 hover:bg-purple-150 transition-colors text-purple-500";
    default:
      return "bg-blue-50 hover:bg-blue-100 transition-colors text-black"; // fallback for unknown status
  }
};

export const MATERIAL_COLUMNS_PMRR = [
  "product_name",
  "quantity",
  "comments",
  "actions",
];

export const MATERIAL_LABELS_PMRR = {
  product_name: "Material",
  comments: "Comments",
  quantity: "Quantity",
  actions: "Action",
};

export const materialColumns_PMRR = ["product_name", "quantity", "comments"];

export const materialLabels_PMRR = {
  product_name: "Material",
  quantity: "Quantity",
  comments: "Comments",
};

export const ADMIN_APPROVAL_BUTTONS = [
  {
    label: "Mark as Failed",
    status: PMRR_STATUS.FAILED,
    color: "bg-red-500 hover:bg-red-700",
  },
  {
    label: "Approve",
    status: PMRR_STATUS.APPROVED,
    color: "bg-primary hover:bg-blue-700",
  },
];

export const BILLING_COMPLETION_BUTTONS = [
  {
    label: "Mark as Failed",
    status: PMRR_STATUS.FAILED,
    color: "bg-red-500 hover:bg-red-700",
  },
  {
    label: "Mark as Completed",
    status: PMRR_STATUS.COMPLETED,
    color: "bg-green-600 hover:bg-green-700",
  },
];

export const INCHARGE_SUBMIT_BUTTONS = [
  { label: "Save as Draft", status: PMRR_STATUS.DRAFT },
  { label: "Submit", status: PMRR_STATUS.PENDING_APPROVAL },
];
